import styled, { css } from 'styled-components'
import { inputgray, darkblue, white, red, black } from '../../styles/colors'
import { minmedia } from '../../styles/media-queries'

export const Cta = styled.div`
  background: linear-gradient(to right, ${inputgray}, ${darkblue});
  padding: 0 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 1.5rem;
  height: 180px;
  width: 100%;
  margin-top: ${props => (props.mt ? '3rem' : '0')};
  ${minmedia.large`
    margin-bottom: 0;
    padding: 0 3rem;
    height: ${props => (props.size === 'medium' ? '250px' : props.size === 'small' ? '200px' : '350px')};
  `};
  ${props =>
    props.size === 'small' &&
    css`
      ${Title} {
        font-size: 24px;
      }
      ${Subtitle} {
        font-size: 18px;
      }
      ${Button} {
        font-size: 18px;
      }
    `};
`

export const Background = styled.div`
  width: 40%;
  height: calc(100% + 2rem);
  background-size: contain;
  background-position: bottom;
  margin-top: -2rem;
  position: relative;
  background-repeat: no-repeat;
`

export const ContentContainer = styled.div`
  text-align: center;
  width: 50%;
  position: relative;
  z-index: 3;
`

export const Title = styled.div`
  color: ${white};
  font-size: 24px;
  margin: 0 auto;
  margin-bottom: 0.5rem;
  font-weight: 700;
  max-width: 400px;
  ${minmedia.large`
    font-size: 30px;
  `};
  @media screen and (max-width: 321px) {
    font-size: 20px;
  }
`

export const Subtitle = styled.div`
  font-size: 22px;
  color: ${white};
  ${minmedia.large`
    font-size: 24px;
  `};
  @media screen and (max-width: 321px) {
    font-size: 16px;
  }
`

export const Button = styled.a`
  transition: all 0.5s;
  text-decoration: none;
  display: inline-block;
  color: ${white};
  background: ${red};
  font-size: 18px;
  padding: 0.75rem 2rem;
  border-radius: 0.25rem;
  margin-top: 1rem;
  ${minmedia.large`
    font-size: 22px;
    margin-top: 1.5rem;
  `};
  @media screen and (max-width: 321px) {
    font-size: 16px;
  }
  &:hover {
    background: ${black};
  }
`



// WEBPACK FOOTER //
// ./src/components/EmployeeCTA/styles.js